module.exports = __webpack_public_path__ + "97236722ff4723d69969c0dfbc98352c.svg";